import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Assigns Vehicle Groups to a Routing Profile
 * @param driverGroupId The ID of the Routing Profile who the Vehicle Groups are being assigned to
 * @param unassignIds The IDs of the Vehicle Groups who are being assigned
 */
export function postRoutingProfileVehicleGroupsAssign(
  this: unknown,
  routingProfileId: number,
  assignIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .routingProfileVehicleGroupsAssignUrl(routingProfileId),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            vehicleGroupIds: assignIds,
          }),
        }
      )
    )
  ).pipe(ignoreData());
}
